import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/longTermReservation/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/longTermReservation/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/whg-park/api/longTermReservation/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/longTermReservation/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/longTermReservation/update',
    method: 'post',
    data: data
  });
}
export function fetchCompanyList(data) {
  return request({
    url: '/whg-park/api/companyManage/list',
    method: 'post',
    data: data
  });
}